import { render } from "./formtextarea.vue?vue&type=template&id=6c8b30a4"
import script from "./formtextarea.vue?vue&type=script&lang=js"
export * from "./formtextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__